import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { margin } from 'styled-system';
import { __UNSAFE_SPACE_TO_DIMSUM } from '@elliemae/ds-system';
import ActionItem from './ActionItem.js';

/* eslint-disable react/forbid-prop-types */
var ActionsNode = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1umfb8g-0"
})(["display:flex;flex-direction:row;padding-left:", ";overflow:hidden;", ""], function (props) {
  return __UNSAFE_SPACE_TO_DIMSUM(props.theme.space.m);
}, margin);

function Actions(_ref) {
  var _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? [] : _ref$actions,
      centerActions = _ref.centerActions,
      rightActions = _ref.rightActions;
  if (actions.length < 1) return null;
  return /*#__PURE__*/React.createElement(ActionsNode, {
    marginLeft: !!rightActions && 'auto',
    marginRight: !!centerActions && 'auto'
  }, actions.map(function (action, key) {
    return /*#__PURE__*/React.createElement(ActionItem, {
      key: key
    }, action);
  }));
}

Actions.propTypes = {
  actions: PropTypes.array,
  centerActions: PropTypes.bool,
  rightActions: PropTypes.bool
};

export default Actions;
export { Actions };
//# sourceMappingURL=Actions.js.map
